const KEY = "cl_return_to";

// Only same-site paths like "/daily" or "/journal?x=1"; never "//host", schemes, or auth/payment pages.
export const safeLocalPath = (path) => {
  if (typeof path !== "string") return "/";
  const p = path.trim();
  if (!p.startsWith("/") || p.startsWith("//") || p.includes("\\") || p.length > 200 || /[\u0000-\u001F\u007F]/.test(p)) return "/";
  if (/^\/(auth|payment)(\/|$|\?)/.test(p) || p.split("?")[0].includes(":")) return "/";
  return p;
};

export const rememberReturnTo = () => {
  const { pathname, search } = window.location;
  try { sessionStorage.setItem(KEY, safeLocalPath(pathname + search)); } catch (e) {}
};

export const peekReturnTo = () => {
  try { return safeLocalPath(sessionStorage.getItem(KEY) || "/"); } catch (e) { return "/"; }
};

export const takeReturnTo = () => {
  const p = peekReturnTo();
  clearReturnTo();
  return p;
};

export const clearReturnTo = () => {
  try { sessionStorage.removeItem(KEY); } catch (e) {}
};
